module.exports = __webpack_public_path__ + "media/images/basic_logos/download-rounded-9ad1495c33b8f894127bcbb5843f89d6.svg";